import React, { useEffect, useRef, useState } from 'react';
import "./TimeLineStepper.css";
import { Step, StepLabel, Stepper } from '@mui/material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';



// Connector styling
const CustomConnector = styled(StepConnector, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'activeStep',
})(({ color = '#29ABE2', activeStep }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: '.3rem',
    left: 'calc(-50% + 0.35rem)',
    right: 'calc(50% + 0.3rem)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: color,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: color,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderTopWidth: 2,
    borderRadius: 1,
    borderColor: '#E8E8E8',
  },
}));

// Step icon component
const StepEmptyIcon = ({ isCompleted, isActive, activeColor, inactiveColor, inactiveBulletBorder, activeBulletBg }) => {
  const bg = isActive
    ? activeBulletBg || activeColor
    : isCompleted
      ? activeColor
      : inactiveColor;

  const border = !isCompleted && !isActive ? `1px solid ${inactiveBulletBorder}` : "none";

  return (
    <>
      {!isActive && (
        <div
          style={{
            background: bg,
            height: '.7rem',
            width: '.7rem',
            borderRadius: '50%',
            display: 'inline-block',
            alignSelf: 'center',
            border: border,
            zIndex: "10"
          }}
        />
      )}

      {isActive && (
        <span className="icon-active_icon_timeLine_stepper" style={{
          zIndex: "10",
          height: ".7rem",
          transform: "translateY(-.15rem)"
        }}>
          <span className="path1"></span>
          <span className="path2"></span>
          <span className="path3"></span>
        </span>
      )}
    </>
  );
};


const calculateDifferences = (data) => {
  return data.map((item, index) => {
    if (index === data.length - 1) return null;

    const current = data[index];
    const next = data[index + 1];

    if (!current.date || !next.date) return null;

    const currentDate = new Date(current.date);
    const nextDate = new Date(next.date);

    if (isNaN(currentDate) || isNaN(nextDate)) return null;

    const dayDiff = Math.round((nextDate - currentDate) / (1000 * 60 * 60 * 24));

    const currentValue = current.value ?? 0;
    const nextValue = next.value ?? 0;
    const valueDiff = nextValue - currentValue;

    return {
      days: dayDiff,
      value: valueDiff
    };
  }).filter(Boolean);
};

export const TimeLineStepper = ({
  data = [],
  label,
  activeStep = 0,
  connectorsColor,
  bulletsColor = '#29ABE2',
  activeBulletColor = "#35e28b",
  inactiveBulletColor = '#FFFFFF',
  inactiveBulletBorder = '#E8E8E8',
  activeLabelColor = "#29ABE2",
  showSecondLabel = false,
  secondLabelColumnName,
}) => {
  const differences = calculateDifferences(data);

  return (
    <section className='timeline-stepper-cont' style={{ position: "relative" }}>
      <div className="connector-labels"
      // style={{ width: `${labelsWidth}rem`, transition: 'width 0.3s ease' }}
      >
        {differences.map((diff, index) => (
          <div key={index} className="connector-label"
          >
            {/* <div style={{ fontWeight: 600 }}>{diff.value}</div> */}
            <div style={{ fontSize: 'var(--p-size)', color: connectorsColor }}>{diff.days}</div>
          </div>
        ))}
      </div>

      <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={<CustomConnector color={connectorsColor} activeStep={activeStep} />}
        sx={{
          alignItems: 'center',
          height: '100%',
          minHeight: "3rem",
          padding: 0,
          margin: 0,
        }}
      >
        {data.map((e, index) => {
          const isCompleted = index < activeStep;
          const isActive = index === activeStep;

          return (
            <Step key={index}>
              <StepLabel
                className={`step-label-${index}`}
                sx={{
                  '& .MuiStepLabel-label': {
                    fontSize: 'calc(var(--p-size))',
                    fontWeight: "400",
                    color: "var(--black-mid)"
                  },
                  '& .MuiStepIcon-root': {
                    fontSize: '1rem',
                  },
                  ".css-12eb3rq-MuiStepLabel-label.Mui-active": {
                    color: activeLabelColor
                  },
                  ".css-p8xe3-MuiStepLabel-labelContainer.MuiStepLabel-alternativeLabel": {
                    maxHeight: "1.5rem",
                  }
                }}
                StepIconComponent={() => (
                  <StepEmptyIcon
                    isCompleted={isCompleted}
                    isActive={isActive}
                    activeColor={bulletsColor}
                    inactiveColor={inactiveBulletColor}
                    inactiveBulletBorder={inactiveBulletBorder}
                    activeBulletBg={activeBulletColor}
                  />
                )}

              >
                <p className='timeline-stepper-label'>
                  {e[label]}
                  {showSecondLabel && (
                    <>
                      <br />
                      {(() => {
                        const value = e[secondLabelColumnName];
                        const date = new Date(value);
                        const isValidDate = !isNaN(date.getTime());

                        return isValidDate
                          ? `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()}`
                          : value;
                      })()}

                    </>
                  )}
                </p>

              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </section>
  );
};
